<div class="widget-area">
  <div class="widget-archives footer-widget mb-50">
    <h3 class="widget-title">Alumni</h3>
    <ul>
      <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <ul class="sub-menu">
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/alumni/directory">Directory</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/alumni/enroll-now">Enroll Now</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/alumni/testimonials">Testimonials</a></li>
        </ul>
      </li>
    </ul>
  </div>
</div>
